import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import insertNodeIntoPage from 'app/app/editor/page/insertNodeIntoPage';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { findAllNestedComponentsUid } from 'app/app/editor/page';

export default function MenuItemPaste({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();

    const copyBuffer = ctx.copyBuffer.node;
    const deleteAfterPaste = ctx.copyBuffer.cut;

    const disabled =
        copyBuffer == null || (deleteAfterPaste && findAllNestedComponentsUid(copyBuffer, true).includes(openWithUid));

    return (
        <MenuItem
            disabled={disabled}
            onClick={() => {
                if (!copyBuffer) {
                    return false;
                }
                const newPage = insertNodeIntoPage(ctx.page, copyBuffer, openWithUid, undefined, deleteAfterPaste);
                if (deleteAfterPaste) {
                    ctx.setCopyBuffer({ node: null, cut: false });
                }
                ctx.setPage(newPage, false);
                ctx.sendMessage({ name: 'reloadPage' });
                handleClose();
            }}
        >
            <Box sx={styles.iconHolder}>
                <IconMi icon={'bulk-load-external-report'} />
            </Box>
            <Box>{t('node_context_menu.paste')}</Box>
        </MenuItem>
    );
}
